import { Icon, Tooltip } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { useTranslation } from 'react-i18next';
import { TransactionChargeDto } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList, Text } from '@tiendanube/components';
import { CurrencyPrice, Stack } from 'commons/components';

interface Attributes {
  transactionCharge: TransactionChargeDto;
}

function OrderMerchantChargeAmountRow({
  transactionCharge,
}: Readonly<Attributes>): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS, {
    keyPrefix: 'orderSummaryCard.tableAmounts',
  });

  const capitalizeFirstLetter = (string: string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const tooltipContent = (() => {
    if (transactionCharge.type === 'tax') {
      return transactionCharge.description; //must be IIBB n%
    }
    const embeddedChargeTooltip =
      transactionCharge.embedded_charges?.map((ec) =>
        t(`embeddedCharges.${ec}.tooltip`),
      ) ?? [];
    if (embeddedChargeTooltip.length !== 0) {
      return capitalizeFirstLetter(embeddedChargeTooltip.join(' + '));
    }
    return capitalizeFirstLetter(
      t(`merchantChargeTypes.${transactionCharge.type}.tooltip`),
    );
  })();

  return (
    <DataList.Row id="merchant_charge_details">
      <DataList.Cell width={70}>
        <Stack spacing="tight">
          <Text>
            {t(`merchantChargeTypes.${transactionCharge.type}.description`)}
          </Text>
          {!!tooltipContent && (
            <Tooltip content={tooltipContent} position="top">
              <Icon
                color="primary-interactive"
                source={<InfoCircleIcon size="small" />}
              />
            </Tooltip>
          )}
        </Stack>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          appearance="danger"
          price={-transactionCharge.amount.value}
          currency={transactionCharge.amount.currency}
          block
          textAlign="right"
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderMerchantChargeAmountRow;
